import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";
import Home from "./User/Home";
import AdminPanel from "./Admin/AdminPanel";
import VentanillaElectronica from "./VentanillaElectronica";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom"; // Asegúrate de importar useNavigate

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  ); 
}

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Solo redirigimos automaticamente cuando se entra por la raiz ("/").
    // Antes este efecto se disparaba para CUALQUIER ruta (incluida
    // /ventanilla-electronica), asi que un enlace directo a la ventanilla
    // publica acababa siempre rebotado a /login antes de verse.
    if (location.pathname !== "/") return;

    if (localStorage.getItem("token")) {
      if (localStorage.getItem("rol") === "admin") {
        navigate("/admin");
      } else navigate("/home");
    } else {
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/ventanilla-electronica" element={<VentanillaElectronica />} />
      </Routes>
    </div>
  );
};

export default App;
